// START_MODULE linkedin_icon
// START_CONTRACT
// PURPOSE: Render the LinkedIn brand mark in the same configurable icon surface as the other social links.
// OPERATIONAL_CONTEXT: Used beside the LinkedIn community link in the landing-page social section.
// CONTRACT: Respect the shared size and color props while forwarding standard SVG attributes.
// KEYWORDS: linkedin, social-icon, svg
// COMPLEXITY: 1
// END_CONTRACT
import React from 'react';

import { IconProps } from './interfaces/iconProps';

const LinkedInIcon: React.FC<IconProps> = ({ size = 200, color = 'currentColor', ...restProps }) => (
  <svg
    {...restProps}
    aria-hidden="true"
    fill={color}
    height={`${size}px`}
    viewBox="0 0 24 24"
    width={`${size}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.047c.475-.9 1.637-1.85 3.37-1.85 3.602 0 4.267 2.371 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 1 1 0-4.124 2.062 2.062 0 0 1 0 4.124zM3.56 9h3.555v11.452H3.56V9zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

export default LinkedInIcon;

// END_MODULE linkedin_icon
